export default __webpack_public_path__ + "static/media/Blade of Endless Night.08ef5cf3.jpg";